import globalEvents from "@/events/global-events"
import eventHandlers from "./event-handlers"

let _eventBus = null

function init(bus) {
  if (_eventBus) throw new Error("Ayva event bus has already been initialized!")

  _eventBus = bus
  registerEventListeners()
}

function registerEventListeners() {
  _eventBus.on(globalEvents.LOG_IN, eventHandlers.handleLogInEvent)
  _eventBus.on(globalEvents.LOG_OUT, eventHandlers.handleLogOutEvent)
}

function getBus() {
  if (!_eventBus) throw new Error("Ayva event bus has not yet been initialized, call init() first")

  return _eventBus
}

export default {
  init,
  getBus
}
